import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Breadcrumbs,
  Button,
  Link as MLink,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PageHeader from '../components/PageHeader';
import { OrdersContainer } from '../container/OrdersContainer';
import { useUserCheckPermission } from '../hooks/useUserCheckPermission';
import { Link } from 'react-router-dom';
import { HomeTwoTone } from '@mui/icons-material';

export default function OrdersPage() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [balancesQueryDialogOpen, setBalancesQueryDialogOpen] = useState(false);
  const { can } = useUserCheckPermission();

  return (
    <Box>
      <PageHeader
        title={t('ordersPage.title')}
        actions={
          <Button
            color="secondary"
            onClick={() => setBalancesQueryDialogOpen(true)}
            fullWidth={isMobile}
          >
            {t('ordersPage.paySomeoneElsesAmount')}
          </Button>
        }
        grid={[
          {
            xs: 12,
            md: 6,
          },
          {
            xs: 12,
            md: 6,
          },
        ]}
      />
      <Breadcrumbs sx={{ mb: 1 }}>
        <MLink
          component={Link}
          to="/"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <HomeTwoTone />
        </MLink>
        <MLink component={Link} to="/account">
          {t('nav.account')}
        </MLink>
        <Typography>{t('nav.orders')}</Typography>
      </Breadcrumbs>

      {can('getMemberSalesOrderInfo') && (
        <OrdersContainer
          balancesQueryDialogOpen={balancesQueryDialogOpen}
          setBalancesQueryDialogOpen={setBalancesQueryDialogOpen}
        />
      )}
    </Box>
  );
}
